// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookings-cardlist-frame {
    width: 100%;
    padding: 0px;
    margin: 0px;
    background-color: var(--color-grey000);
}`, "",{"version":3,"sources":["webpack://./src/components/cardLists/BookingsCardList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sCAAsC;AAC1C","sourcesContent":[".bookings-cardlist-frame {\n    width: 100%;\n    padding: 0px;\n    margin: 0px;\n    background-color: var(--color-grey000);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
